import { AnyRoute, redirect } from '@tanstack/react-router';
import StudentCourseProgress from '@screens/instructor/studentCourseProgress/StudentCourseProgress';
import { createRoutesFromConfig, RouteConfig } from './routeHelpers';
import { SingleCoursePage } from '@new/features/courses/pages/SingleCoursePage';
import { CoursePage } from '@new/features/courses/pages/CoursePage';
import { LessonDetailPage } from '@new/features/lessons/pages/LessonDetailPage';
import { ObjectiveDetailPage } from '@new/features/objectives/pages/ObjectiveDetailPage';
import LessonEdit from '@screens/lessons/LessonEdit';
import ObjectiveEdit from '@screens/objectives/ObjectiveEdit';
import { coursesApi, Role, Visibility } from '@teachur/http-client';

export function createCourseRoutes(parent: AnyRoute) {
  const courseConfigs: RouteConfig[] = [
    {
      path: 'courses',
      component: CoursePage,
    },
    {
      path: 'courses/$courseId',
      component: SingleCoursePage,
      beforeLoad: async ({ params, context }) => {
        const user = await context.getUser();
        const response = await coursesApi.get(Number(params.courseId));
        const course = response.data;

        const isAdmin = user.role === Role.Admin || user.role === Role.SuperAdmin;

        const isRestricted =
          course.visibility === Visibility.Private || course.visibility === Visibility.Archived;

        if (isRestricted && !isAdmin) {
          throw redirect({
            to: '/courses',
          });
        }
      },
    },
    { path: 'courses/$courseId/students/$id', component: StudentCourseProgress },
    { path: 'courses/$courseId/lessons/$lessonId', component: LessonDetailPage },
    {
      path: 'courses/$courseId/lessons/$lessonId/objectives/$objectiveId',
      component: ObjectiveDetailPage,
    },
    {
      path: 'courses/$courseId/objectives/$objectiveId',
      component: ObjectiveDetailPage,
    },
    { path: 'courses/$courseId/lessons/$lessonId/edit', component: LessonEdit },
    {
      path: 'courses/$courseId/lessons/$lessonId/objectives/$objectiveId/edit',
      component: ObjectiveEdit,
    },
    { path: 'courses/$courseId/objectives/$objectiveId/edit', component: ObjectiveEdit },
  ];

  return createRoutesFromConfig(parent, courseConfigs);
}
